// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Linotype-DIN-Next-LT-Arabic-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/Linotype-DIN-Next-LT-Arabic-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/Linotype-DIN-Next-LT-Arabic-UltraLight.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/Linotype-DIN-Next-LT-Arabic-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./fonts/Linotype-DIN-Next-LT-Arabic-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./fonts/Linotype-DIN-Next-LT-Arabic-Heavy.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./fonts/Linotype-DIN-Next-LT-Arabic-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../components/images/icon-line.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../components/images/landing-page-mob.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "DINNextLTLight";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: "DINNextLTRegular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: "DINNextLTUltraLight";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@font-face {
  font-family: "DINNextLTMedium";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
@font-face {
  font-family: "DINNextLTBold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
@font-face {
  font-family: "DINNextLTHeavy";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
@font-face {
  font-family: "DINNextLTBlack";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
#root {
  position: relative;
  overflow: hidden;
}

:root {
  --white-color: #ffffff;
  --white-color-obicty: #FFFFFF29;
  --black-color: #000000;
  --black-color-obicty: #00000052;
  --primary-color: #EBDD36;
  --primary-two-color: #231f20;
  --primary-three-color: #020524;
  --secondary-one-color: #32a361;
  --secondary-two-color: #e01f3d;
  --secondary-three-color: #e6cd2f;
  --secondary-four-color: #204496;
  --font-din-next-Regular: DINNextLTRegular;
  --font-din-next-Light: DINNextLTLight;
  --font-din-next-UltraLight: DINNextLTUltraLight;
  --font-din-next-Medium: DINNextLTMedium;
  --font-din-next-Heavy: DINNextLTHeavy;
  --font-din-next-Black: DINNextLTBlack;
  --font-din-next-Bold: DINNextLTBold;
  --font-heading-size: 40px;
  --font-title-size: 24px;
  --font-paragraphone-size: 24px;
  --font-paragraphtwo-size: 16px;
  --space-gap-sm: 8px;
  --space-gap-md: 16px;
  --border-radius-sm: 8px;
  --border-radius-md: 16px;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  direction: rtl;
}
*:focus-visible {
  outline: none !important;
}

div, p, span, h1, h2, h3, h4, h5, h6 {
  margin: 0px;
  padding: 0px;
}

a {
  text-decoration: none !important;
}

.row {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -15px;
}

.h-100 {
  height: 100%;
}

.w-100 {
  width: 100%;
}

.d-flex {
  display: flex;
}

.align-items-center {
  align-items: center;
}

.align-items-start {
  align-items: flex-start;
}

.align-items-end {
  align-items: flex-end;
}

.justify-content-center {
  justify-content: center;
}

.justify-content-between {
  justify-content: space-between;
}

.justify-content-around {
  justify-content: space-around;
}

.flex-column {
  flex-direction: column;
}

.flex-row {
  flex-direction: row;
}

.navbar-landing {
  padding: 25px 0px !important;
}
.navbar-landing__download {
  padding: 12px 16px;
  background-color: var(--white-color);
  display: flex;
  align-items: center;
  gap: var(--space-gap-sm);
  border-radius: var(--border-radius-sm);
  -webkit-border-radius: var(--border-radius-sm);
  -moz-border-radius: var(--border-radius-sm);
  -ms-border-radius: var(--border-radius-sm);
  -o-border-radius: var(--border-radius-sm);
}
.navbar-landing__download .text {
  font-size: 14px;
  font-weight: 500;
  color: var(--black-color);
  font-family: var(--font-din-next-Medium);
  height: 21px;
  line-height: 15px;
}
.navbar-landing__download .download {
  width: 21px;
  height: 21px;
  object-fit: cover;
}
.navbar-landing__logo {
  width: 44px;
  height: 44px;
  display: block;
}
.navbar-landing__logo .logo {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@media screen and (max-width: 567px) {
  .navbar-landing {
    padding: 15px 0px 25px 0px !important;
    /*
    &__download {
        display: none;
    }
    */
  }
}
.main-page {
  width: 100%;
  height: 100vh;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
}
.main-page .overlay {
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, rgba(15, 15, 15, 0) -1.79%, rgba(15, 15, 15, 0.9) 113.53%);
}

.landing-page {
  height: calc(100vh - 95px);
}
.landing-page .container {
  height: 100%;
}
.landing-page__flex-container {
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: 20px;
  height: 100%;
  padding-bottom: 20px;
}
.landing-page__form {
  padding: 56px 40px;
  background-color: var(--black-color-obicty);
  border-radius: var(--border-radius-md);
  -webkit-border-radius: var(--border-radius-md);
  -moz-border-radius: var(--border-radius-md);
  -ms-border-radius: var(--border-radius-md);
  -o-border-radius: var(--border-radius-md);
  min-height: 571px;
  display: flex;
  flex-direction: column;
  gap: 40px;
}
.landing-page__form .form__title {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--space-gap-sm);
}
.landing-page__form .form__title h5,
.landing-page__form .form__title p {
  color: var(--white-color);
  text-align: right;
}
.landing-page__form .form__title h5 {
  font-weight: 700;
  font-size: 25px;
  line-height: 32.5px;
  font-family: var(--font-din-next-Bold);
}
.landing-page__form .form__title P {
  font-weight: 400;
  font-size: 18px;
  line-height: 27px;
  font-family: var(--font-din-next-Regular);
}
.landing-page__form .form {
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1 1;
}
.landing-page__form ul.footerWrapper.formRelative .fmFooter {
  padding: 0px !important;
}
.landing-page__form form {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 40px;
}
.landing-page__form form .from-control {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.landing-page__form form button {
  width: 100%;
  height: 45px;
  background-color: var(--primary-color);
  border-radius: 14px;
  -webkit-border-radius: 14px;
  -moz-border-radius: 14px;
  -ms-border-radius: 14px;
  -o-border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
}
.landing-page__form form button .text {
  font-family: var(--font-din-next-Bold);
  font-weight: bold;
  font-size: 14px;
  line-height: 21px;
  color: var(--black-color);
}
.landing-page__form form button:hover, .landing-page__form form button:disabled {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
}
.landing-page__form form button:hover .text, .landing-page__form form button:disabled .text {
  color: #626262;
}
.landing-page__content {
  min-height: 304px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.landing-page__content__top {
  display: flex;
  flex-direction: column;
  gap: 16px;
  text-align: right;
}
.landing-page__content__top .build-status {
  padding: 8px 24px;
  background-color: var(--white-color-obicty);
  border-radius: 80px;
  -webkit-border-radius: 80px;
  -moz-border-radius: 80px;
  -ms-border-radius: 80px;
  -o-border-radius: 80px;
  width: max-content;
  display: flex;
  align-items: center;
  justify-content: center;
}
.landing-page__content__top .build-status .text {
  font-family: var(--font-din-next-Medium);
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  color: var(--white-color);
}
.landing-page__content__top h3.title {
  font-size: 40px;
  font-family: var(--font-din-next-Bold);
  font-weight: 900;
  line-height: 48px;
  color: var(--white-color);
}
.landing-page__content__top .location {
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 16px;
}
.landing-page__content__top .location .icon-location {
  width: 28px;
  height: 28px;
  object-fit: cover;
}
.landing-page__content__top .location .text {
  font-family: var(--font-din-next-Regular);
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: var(--white-color);
}
.landing-page__content__basic-info {
  width: max-content;
  padding: 12px 24px;
  background-color: var(--white-color-obicty);
  border-radius: var(--border-radius-sm);
  -webkit-border-radius: var(--border-radius-sm);
  -moz-border-radius: var(--border-radius-sm);
  -ms-border-radius: var(--border-radius-sm);
  -o-border-radius: var(--border-radius-sm);
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 32px;
  height: 83px;
}
.landing-page__content__basic-info__card {
  display: flex;
  flex-direction: row;
  gap: 16px;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  height: 100%;
}
.landing-page__content__basic-info__card__icon {
  width: 24px;
  height: 24px;
}
.landing-page__content__basic-info__card__icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.landing-page__content__basic-info__card__text {
  text-align: right;
}
.landing-page__content__basic-info__card__text h6 {
  font-size: 16px;
  font-family: var(--font-din-next-Regular);
  font-weight: 400;
  line-height: 24px;
  color: var(--white-color);
}
.landing-page__content__basic-info__card__text p {
  font-size: 18px;
  font-family: var(--font-din-next-Regular);
  font-weight: 700;
  line-height: 27px;
  color: var(--white-color);
}
.landing-page__content__basic-info__card:last-child {
  border-left: none;
  padding-left: 0px;
  margin-left: 0px;
}
.landing-page__content__basic-info__line {
  width: 1px;
  min-height: 80%;
  max-height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  opacity: 20%;
}
.landing-page__content__brind {
  width: max-content;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  border-radius: 5.89px;
  padding: 5.89px 8px;
  background-color: #FFFFFF;
}
.landing-page__content__brind img {
  width: 175px;
  height: 50px;
}
.landing-page__content__brind .text {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #05555C;
  gap: 4px;
  border-radius: 5.89px;
  padding: 5px 15px;
}
.landing-page__content__brind .text .des {
  font-family: var(--font-din-next-Regular);
  font-weight: 400;
  font-size: 12px;
  line-height: 21px;
  color: var(--white-color);
}
.landing-page__content__brind .text .number {
  text-align: center;
  background-color: #FFFFFF;
  padding: 2px 5px;
  border-radius: 3px;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  -ms-border-radius: 3px;
  -o-border-radius: 3px;
  font-family: var(--font-din-next-Regular);
  font-weight: 700;
  font-size: 12px;
  line-height: 21px;
  color: #000000;
}
.landing-page__content__app-story {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
}
.landing-page__content__app-story h3 {
  margin-bottom: 0px;
  color: #FFFFFF;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  font-family: var(--font-din-next-Regular);
}
.landing-page__content__app-story .list {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
}
.landing-page__content__app-story .list a {
  width: 150px;
  height: 44px;
}
.landing-page__content__app-story .list a img {
  width: 100%;
  height: 100%;
}
.landing-page__form-mob {
  display: none;
}

.landing-page-app-story {
  padding: 30px 0px;
  background-color: #fff;
  display: none;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  align-items: center;
  gap: 16px;
}
.landing-page-app-story h3 {
  margin-bottom: 0px;
  color: #1C1B13;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  font-family: var(--font-din-next-Regular);
}
.landing-page-app-story .list {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
}
.landing-page-app-story .list a {
  width: 150px;
  height: 44px;
}
.landing-page-app-story .list a img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.landing-page-mob {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-position: center;
  background-size: cover;
}

@media (max-width: 992px) {
  .main-page {
    height: 80vh;
  }
  .main-page .overlay {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .landing-page {
    height: max-content;
  }
  .landing-page__flex-container {
    align-items: end;
    flex-direction: column;
    gap: 0px;
    height: 100%;
    padding-bottom: 20px;
  }
  .landing-page__form {
    padding: 20px 0px;
    background-color: transparent;
    border-radius: none;
    -webkit-border-radius: none;
    -moz-border-radius: none;
    -ms-border-radius: none;
    -o-border-radius: none;
    min-height: -moz-fit-content;
    min-height: fit-content;
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
  }
  .landing-page__form .form__title h5,
  .landing-page__form .form__title p {
    color: #1C1B13;
  }
  .landing-page__form .form__title h5 {
    font-size: 22px;
  }
  .landing-page__form .form__title P {
    font-size: 14px;
    line-height: 21px;
  }
  .landing-page__form form {
    gap: 30px;
  }
  .landing-page__form form .from-control {
    gap: 16px;
  }
  .landing-page__content {
    display: flex;
    min-height: calc(70vh - 95px);
    height: calc(70vh - 95px);
    width: 100%;
    gap: 24px;
    padding-bottom: 24px;
    justify-content: flex-end;
  }
  .landing-page__content__top {
    display: flex;
    flex-direction: column;
    gap: 8px;
    text-align: right;
  }
  .landing-page__content__top .build-status {
    padding: 8px 8px;
    height: max-content;
  }
  .landing-page__content__top h3.title {
    font-size: 22px;
    margin-bottom: 0px;
  }
  .landing-page__content__top .location {
    gap: 8px;
  }
  .landing-page__content__top .location .text {
    font-size: 14px;
  }
  .landing-page__content__basic-info {
    width: max-content;
    padding: 8px 12px;
    gap: 16px;
  }
  .landing-page__content__brind {
    gap: 2px;
    width: 100%;
    justify-content: space-between;
  }
  .landing-page__content__brind .text {
    width: 50%;
  }
  .landing-page__form-web {
    display: none;
  }
}
@media screen and (max-width: 576px) {
  .main-page {
    height: calc(100vh - 144px);
  }
  .landing-page {
    flex: 1 1;
  }
  .landing-page .container {
    height: 95%;
  }
  .landing-page__flex-container {
    justify-content: flex-end;
    padding-bottom: 0px;
    height: 100%;
  }
  .landing-page__content {
    padding-bottom: 0px;
  }
  .landing-page__content__top .location .icon-location {
    width: 16px;
    height: 16px;
  }
  .landing-page__content__basic-info {
    width: 100%;
    gap: 16px;
    padding: 8px;
    height: 60px;
  }
  .landing-page__content__basic-info__line {
    min-height: 90%;
  }
  .landing-page__content__basic-info__card {
    gap: 5px;
    flex: 1 1;
  }
  .landing-page__content__basic-info__card__text h6 {
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
    width: max-content;
  }
  .landing-page__content__basic-info__card__text p {
    font-size: 14px;
    font-family: var(--font-din-next-Medium);
    font-weight: 500;
    line-height: 21px;
    width: max-content;
  }
  .landing-page__content__app-story {
    display: none;
  }
  .landing-page-app-story {
    display: flex;
    height: 144px;
  }
}
.main-page-success {
  min-height: 100vh;
  max-height: max-content;
}

.success {
  min-height: calc(100vh - 95px);
  max-height: max-content;
}
.success .container {
  height: 100%;
}
.success__flex-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
  -webkit-gap: 32px;
  height: 100%;
  padding-bottom: 20px;
  -webkit-padding-bottom: 20px;
}
.success__flex-container .success-image {
  width: 160px;
  height: 160px;
}
.success__flex-container .success-image video {
  width: 100% !important;
  height: 100% !important;
}
.success__flex-container .content {
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  align-items: center;
  gap: 32px;
}
.success__flex-container .top {
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  align-items: center;
  gap: 16px;
}
.success__flex-container .top h6 {
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
  margin-bottom: 0px;
  font-family: var(--font-din-next-Bold);
}
.success__flex-container .top p {
  font-size: 25px;
  font-weight: 400;
  line-height: 31px;
  margin-bottom: 0px;
  font-family: var(--font-din-next-Regular);
}
.success__flex-container .bottom {
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  align-items: center;
  gap: 16px;
}
.success__flex-container .bottom p {
  margin-bottom: 0px;
  color: #807F7B;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  font-family: var(--font-din-next-Regular);
}
.success__flex-container .bottom .list {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
}
.success__flex-container .bottom .list a {
  width: 162px;
  height: 48px;
}
.success__flex-container .bottom .list a img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@media screen and (max-width: 567px) {
  .success {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .success .container {
    height: auto;
  }
  .success__flex-container .success-image {
    width: 140px;
    height: 140px;
  }
  .success__flex-container .top h6 {
    font-size: 22px;
    line-height: 28px;
  }
  .success__flex-container .top p {
    font-size: 16px;
    line-height: 24px;
  }
  .success__flex-container .bottom p {
    font-size: 14px;
    line-height: 21px;
  }
  .success__flex-container .bottom .list {
    gap: 8px;
  }
  .success__flex-container .bottom .list a {
    width: 130px;
    height: 40px;
  }
}
.loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  background-color: #fff;
}
.loading .loading__spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid var(--primary-color);
  border-radius: 50%;
  animation: spin 2s linear infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.input-form {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.input-form label {
  font-family: var(--font-din-next-Regular);
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: var(--white-color);
  text-align: right;
  width: 100%;
  margin-bottom: 0px;
}
.input-form input {
  width: 100%;
  height: 48px;
  padding: 8px 16px;
  border-radius: var(--border-radius-sm);
  -webkit-border-radius: var(--border-radius-sm);
  -moz-border-radius: var(--border-radius-sm);
  -ms-border-radius: var(--border-radius-sm);
  -o-border-radius: var(--border-radius-sm);
  text-align: right;
  font-family: var(--font-din-next-Light);
  font-weight: 700;
  background-color: #fff !important;
}
.input-form input::placeholder {
  font-family: var(--font-din-next-Light);
  font-weight: 700;
  font-size: 14px;
  color: #807F7B;
  font-family: var(--font-din-next-Light);
}
.input-form input:focus {
  outline: none;
  border: var(--bs-border-width) solid var(--bs-border-color);
  box-shadow: none;
}
.input-form input[type=email] {
  direction: ltr;
  text-align: left;
  background-color: #fff !important;
}
.input-form input[type=email]:focus {
  background-color: #fff;
}

.form-group {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.form-group label {
  font-family: var(--font-din-next-Regular);
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: var(--white-color);
  text-align: right;
  width: 100%;
  margin-bottom: 0px;
}
.form-group .tel-phone {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 48px;
  background-color: var(--white-color);
  direction: ltr;
  border-radius: var(--border-radius-sm);
  border: var(--bs-border-width) solid var(--bs-border-color);
  padding: 8px 16px;
}
.form-group .tel-phone .tel-phone-code {
  font-family: var(--font-din-next-Medium);
  font-size: 14px;
  color: #242926;
  font-style: normal;
  font-weight: 500;
}
.form-group .tel-phone .line {
  width: 1px;
  height: 24px;
  background-color: #F0F0EF;
}
.form-group .tel-phone input {
  height: 100%;
  width: 100%;
  flex: 1 1;
  font-family: var(--font-din-next-Medium);
  background-color: #fff !important;
  font-size: 14px;
  color: #242926;
  font-style: normal;
  font-weight: 500;
  flex: 1 1;
  direction: ltr;
  border: var(--white-color);
}
.form-group .tel-phone input::placeholder {
  color: #a3a3a3 !important;
}

.errorfiled {
  color: #ff1010;
  font-size: 14px;
  font-family: var(--font-din-next-Regular);
  font-weight: 600;
}

.is-invalid {
  border: 2px solid red;
}

@media (max-width: 992px) {
  .input-form label,
  .form-group label {
    color: #1C1B13;
  }
}
.not-found {
  height: calc(100vh - 95px);
}
.not-found__flex-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 65px;
  height: 100%;
}
.not-found__flex-container .image {
  width: 397px;
  height: 300px;
}
.not-found__flex-container .image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.not-found__flex-container .content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
}
.not-found__flex-container .content .top {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
}
.not-found__flex-container .content .top h6 {
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
  margin-bottom: 0px;
  font-family: var(--font-din-next-Bold);
  color: #1C1B13;
}
.not-found__flex-container .content .top p {
  font-size: 25px;
  font-weight: 400;
  line-height: 31px;
  margin-bottom: 0px;
  font-family: var(--font-din-next-Regular);
  color: #1C1B13;
}
.not-found__flex-container .content .btn-home {
  padding: 12px 24px;
  background-color: var(--primary-color);
  display: flex;
  align-items: center;
  gap: 8px;
}
.not-found__flex-container .content .btn-home img {
  width: 21px;
  height: 21px;
  object-fit: cover;
}
.not-found__flex-container .content .btn-home span {
  font-family: var(--font-din-next-Bold);
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: var(--black-color);
}

@media screen and (max-width: 768px) {
  .main-page.not {
    height: 100vh;
  }
  .not-found {
    height: min-content;
    padding: 24px 0px;
    margin-top: 40px;
  }
  .not-found__flex-container {
    gap: 40px;
  }
  .not-found__flex-container .image {
    width: 200px;
    height: 150px;
  }
  .not-found__flex-container .content {
    gap: 24px;
  }
  .not-found__flex-container .content .top h6 {
    font-size: 22px;
    line-height: 28px;
  }
  .not-found__flex-container .content .top p {
    font-size: 16px;
    line-height: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/style/main.scss","webpack://./src/style/modules/navbar.module.scss","webpack://./src/style/modules/landing-page.module.scss","webpack://./src/style/modules/success-page.module.scss","webpack://./src/style/modules/loading.module.scss","webpack://./src/style/modules/actions.module.scss","webpack://./src/style/modules/not-found.module.scss"],"names":[],"mappings":"AACA;EACE,6BAAA;EACA,4CAAA;AAAF;AAEA;EACE,+BAAA;EACA,4CAAA;AAAF;AAEA;EACE,kCAAA;EACA,4CAAA;AAAF;AAEA;EACE,8BAAA;EACA,4CAAA;AAAF;AAEA;EACE,4BAAA;EACA,4CAAA;AAAF;AAGA;EACE,6BAAA;EACA,4CAAA;AADF;AAGA;EACE,6BAAA;EACA,4CAAA;AADF;AAIA;EACE,kBAAA;EACA,gBAAA;AAFF;;AAKA;EACI,sBAAA;EACA,+BAAA;EACA,sBAAA;EACA,+BAAA;EAGA,wBAAA;EACA,4BAAA;EACA,8BAAA;EAEA,8BAAA;EACA,8BAAA;EACA,gCAAA;EACA,+BAAA;EAKA,yCAAA;EACA,qCAAA;EACA,+CAAA;EACA,uCAAA;EACA,qCAAA;EACA,qCAAA;EACA,mCAAA;EAMA,yBAAA;EACA,uBAAA;EACA,8BAAA;EACA,8BAAA;EAEA,mBAAA;EACA,oBAAA;EAEA,uBAAA;EACA,wBAAA;AAhBJ;;AAsBA;EACI,SAAA;EACA,UAAA;EACA,sBAAA;EACA,cAAA;AAnBJ;AAoBI;EACE,wBAAA;AAlBN;;AAqBE;EACE,WAAA;EACA,YAAA;AAlBJ;;AAqBE;EACE,gCAAA;AAlBJ;;AAoBE;EACE,aAAA;EACA,eAAA;EACA,eAAA;AAjBJ;;AAmBE;EACE,YAAA;AAhBJ;;AAkBE;EACE,WAAA;AAfJ;;AAiBE;EACE,aAAA;AAdJ;;AAgBE;EACE,mBAAA;AAbJ;;AAeE;EACE,uBAAA;AAZJ;;AAcE;EACE,qBAAA;AAXJ;;AAaE;EACE,uBAAA;AAVJ;;AAYE;EACE,8BAAA;AATJ;;AAWE;EACE,6BAAA;AARJ;;AAUE;EACE,sBAAA;AAPJ;;AASE;EACE,mBAAA;AANJ;;ACjIA;EACI,4BAAA;ADoIJ;AClII;EACI,kBAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,sCAAA;EACA,8CAAA;EACA,2CAAA;EACA,0CAAA;EACA,yCAAA;ADoIR;ACjIQ;EACI,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,wCAAA;EACA,YAAA;EACA,iBAAA;ADmIZ;AChIQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;ADkIZ;AC9HI;EACI,WAAA;EACA,YAAA;EACA,cAAA;ADgIR;AC9HQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;ADgIZ;;AC3HA;EACI;IACI,qCAAA;IACA;;;;KAAA;EDkIN;AACF;AEnLA;EACI,WAAA;EACA,aAAA;EACA,0BAAA;EACA,4BAAA;EACA,2BAAA;EACA,kBAAA;AFqLJ;AEnLI;EACI,WAAA;EACA,YAAA;EACA,8FAAA;AFqLR;;AEhLA;EACI,0BAAA;AFmLJ;AEjLI;EACI,YAAA;AFmLR;AE/KI;EACI,aAAA;EACA,gBAAA;EACA,8BAAA;EACA,SAAA;EACA,YAAA;EACA,oBAAA;AFiLR;AE9KI;EACI,kBAAA;EACA,2CAAA;EACA,sCAAA;EACA,8CAAA;EACA,2CAAA;EACA,0CAAA;EACA,yCAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AFgLR;AE9KQ;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,wBAAA;AFgLZ;AE9KY;;EAEI,yBAAA;EACA,iBAAA;AFgLhB;AE7KY;EACI,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,sCAAA;AF+KhB;AE5KY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yCAAA;AF8KhB;AE1KQ;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AF4KZ;AExKY;EACI,uBAAA;AF0KhB;AEtKQ;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AFwKZ;AEtKY;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AFwKhB;AErKY;EACI,WAAA;EACA,YAAA;EACA,sCAAA;EACA,mBAAA;EACA,2BAAA;EACA,wBAAA;EACA,uBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;AFuKhB;AErKgB;EACI,sCAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;AFuKpB;AEpKgB;EAEI,sCAAA;EACA,kCAAA;AFqKpB;AEnKoB;EACI,cAAA;AFqKxB;AE7JI;EACI,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AF+JR;AE7JQ;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;AF+JZ;AE7JY;EACI,iBAAA;EACA,2CAAA;EACA,mBAAA;EACA,2BAAA;EACA,wBAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AF+JhB;AE7JgB;EACI,wCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;AF+JpB;AE3JY;EACI,eAAA;EACA,sCAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AF6JhB;AE1JY;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;AF4JhB;AE1JgB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AF4JpB;AEzJgB;EACI,yCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;AF2JpB;AEtJQ;EACI,kBAAA;EACA,kBAAA;EACA,2CAAA;EACA,sCAAA;EACA,8CAAA;EACA,2CAAA;EACA,0CAAA;EACA,yCAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AFwJZ;AEtJY;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,oCAAA;EACA,4BAAA;EACA,YAAA;AFwJhB;AEtJgB;EACI,WAAA;EACA,YAAA;AFwJpB;AEtJoB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AFwJxB;AEpJgB;EACI,iBAAA;AFsJpB;AEpJoB;EACI,eAAA;EACA,yCAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AFsJxB;AEnJoB;EACI,eAAA;EACA,yCAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AFqJxB;AEhJgB;EACI,iBAAA;EACA,iBAAA;EACA,gBAAA;AFkJpB;AE9IY;EACI,UAAA;EACA,eAAA;EACA,gBAAA;EACA,yDAAA;EACA,YAAA;AFgJhB;AE3IQ;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;EACA,yBAAA;AF6IZ;AE3IY;EACI,YAAA;EACA,YAAA;AF6IhB;AExIY;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,QAAA;EACA,qBAAA;EACA,iBAAA;AF0IhB;AEvIgB;EACI,yCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;AFyIpB;AErIgB;EACI,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,0BAAA;EACA,uBAAA;EACA,sBAAA;EACA,qBAAA;EACA,yCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AFuIpB;AEjIQ;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AFmIZ;AEjIY;EACI,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yCAAA;AFmIhB;AEhIY;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;AFkIhB;AEhIgB;EACI,YAAA;EACA,YAAA;AFkIpB;AEhIoB;EACI,WAAA;EACA,YAAA;AFkIxB;AExHI;EACI,aAAA;AF0HR;;AErHA;EACI,iBAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AFwHJ;AEtHI;EACI,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yCAAA;AFwHR;AErHI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;AFuHR;AErHQ;EACI,YAAA;EACA,YAAA;AFuHZ;AErHY;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AFuHhB;;AEhHA;EACI,yDAAA;EACA,2BAAA;EACA,sBAAA;AFmHJ;;AEhHA;EACI;IACI,YAAA;EFmHN;EEjHM;IACI,aAAA;IACA,sBAAA;IACA,8BAAA;EFmHV;EE/GE;IACI,mBAAA;EFiHN;EE/GM;IACI,gBAAA;IACA,sBAAA;IACA,QAAA;IACA,YAAA;IACA,oBAAA;EFiHV;EE9GM;IACI,iBAAA;IACA,6BAAA;IACA,mBAAA;IACA,2BAAA;IACA,wBAAA;IACA,uBAAA;IACA,sBAAA;IACA,4BAAA;IAAA,uBAAA;IACA,aAAA;IACA,sBAAA;IACA,SAAA;IACA,WAAA;EFgHV;EE5Gc;;IAEI,cAAA;EF8GlB;EE3Gc;IACI,eAAA;EF6GlB;EE1Gc;IACI,eAAA;IACA,iBAAA;EF4GlB;EExGU;IACI,SAAA;EF0Gd;EExGc;IACI,SAAA;EF0GlB;EEpGM;IACI,aAAA;IACA,6BAAA;IACA,yBAAA;IACA,WAAA;IACA,SAAA;IACA,oBAAA;IACA,yBAAA;EFsGV;EEpGU;IACI,aAAA;IACA,sBAAA;IACA,QAAA;IACA,iBAAA;EFsGd;EEpGc;IACI,gBAAA;IACA,mBAAA;EFsGlB;EEnGc;IACI,eAAA;IACA,kBAAA;EFqGlB;EElGc;IACI,QAAA;EFoGlB;EElGkB;IACI,eAAA;EFoGtB;EE9FU;IACI,kBAAA;IACA,iBAAA;IACA,SAAA;EFgGd;EE5FU;IACI,QAAA;IACA,WAAA;IACA,8BAAA;EF8Fd;EE5Fc;IACI,UAAA;EF8FlB;EExFM;IACI,aAAA;EF0FV;AACF;AEnFA;EACI;IACI,2BAAA;EFqFN;EElFE;IACI,SAAA;EFoFN;EElFM;IACI,WAAA;EFoFV;EEjFM;IACI,yBAAA;IACA,mBAAA;IACA,YAAA;EFmFV;EEhFM;IACI,mBAAA;EFkFV;EE7EkB;IACI,WAAA;IACA,YAAA;EF+EtB;EE1EU;IACI,WAAA;IACA,SAAA;IACA,YAAA;IACA,YAAA;EF4Ed;EE1Ec;IACI,eAAA;EF4ElB;EEzEc;IACI,QAAA;IACA,SAAA;EF2ElB;EExEsB;IACI,eAAA;IACA,gBAAA;IACA,iBAAA;IACA,kBAAA;EF0E1B;EEvEsB;IACI,eAAA;IACA,wCAAA;IACA,gBAAA;IACA,iBAAA;IACA,kBAAA;EFyE1B;EEjEU;IACI,aAAA;EFmEd;EE9DE;IACI,aAAA;IACA,aAAA;EFgEN;AACF;AGzqBA;EACI,iBAAA;EACA,uBAAA;AH2qBJ;;AGvqBA;EACI,8BAAA;EACA,uBAAA;AH0qBJ;AGxqBI;EACI,YAAA;AH0qBR;AGxqBI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,iBAAA;EACA,YAAA;EACA,oBAAA;EACA,4BAAA;AH0qBR;AGxqBQ;EACI,YAAA;EACA,aAAA;AH0qBZ;AGxqBY;EACI,sBAAA;EACA,uBAAA;AH0qBhB;AGtqBQ;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AHwqBZ;AGpqBQ;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AHsqBZ;AGpqBY;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sCAAA;AHsqBhB;AGnqBY;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yCAAA;AHqqBhB;AGjqBQ;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AHmqBZ;AGjqBY;EACI,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yCAAA;AHmqBhB;AGhqBY;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;AHkqBhB;AGhqBgB;EACI,YAAA;EACA,YAAA;AHkqBpB;AGhqBoB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AHkqBxB;;AGrpBA;EACI;IACI,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,uBAAA;EHwpBN;EGvpBM;IACI,YAAA;EHypBV;EGtpBU;IACI,YAAA;IACA,aAAA;EHwpBd;EGppBc;IACI,eAAA;IACA,iBAAA;EHspBlB;EGnpBc;IACI,eAAA;IACA,iBAAA;EHqpBlB;EGhpBc;IACI,eAAA;IACA,iBAAA;EHkpBlB;EG/oBc;IACI,QAAA;EHipBlB;EG/oBkB;IACI,YAAA;IACA,YAAA;EHipBtB;AACF;AIxyBA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;AJ0yBJ;AIzyBI;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,0CAAA;EACA,kBAAA;EACA,kCAAA;AJ2yBR;AIzyBI;EACI;IAAK,uBAAA;EJ4yBX;EI3yBM;IAAO,yBAAA;EJ8yBb;AACF;;AKr0BA;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;ALw0BJ;AKt0BI;EACI,yCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;ALw0BR;AKr0BI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,sCAAA;EACA,8CAAA;EACA,2CAAA;EACA,0CAAA;EACA,yCAAA;EACA,iBAAA;EACA,uCAAA;EACA,gBAAA;EACA,iCAAA;ALu0BR;AKr0BQ;EACI,uCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,uCAAA;ALu0BZ;AKp0BQ;EACI,aAAA;EACA,2DAAA;EACA,gBAAA;ALs0BZ;AKj0BI;EACI,cAAA;EACA,gBAAA;EACA,iCAAA;ALm0BR;AKl0BQ;EACI,sBAAA;ALo0BZ;;AK9zBA;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;ALi0BJ;AK/zBI;EACI,yCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;ALi0BR;AK9zBI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,oCAAA;EACA,cAAA;EACA,sCAAA;EACA,2DAAA;EACA,iBAAA;ALg0BR;AK9zBQ;EACI,wCAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;ALg0BZ;AK5zBQ;EACI,UAAA;EACA,YAAA;EACA,yBAAA;AL8zBZ;AK1zBQ;EACI,YAAA;EACA,WAAA;EACA,SAAA;EACA,wCAAA;EACA,iCAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;EACA,0BAAA;AL4zBZ;AK1zBY;EACI,yBAAA;AL4zBhB;;AKnzBA;EACI,cAAA;EACA,eAAA;EACA,yCAAA;EACA,gBAAA;ALszBJ;;AKlzBA;EACI,qBAAA;ALqzBJ;;AKjzBA;EAIQ;;IACI,cAAA;ELkzBV;AACF;AMn8BA;EACI,0BAAA;ANq8BJ;AMl8BI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,YAAA;ANo8BR;AMl8BQ;EACI,YAAA;EACA,aAAA;ANo8BZ;AMl8BY;EACI,WAAA;EACA,YAAA;EACA,iBAAA;ANo8BhB;AMh8BQ;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;ANk8BZ;AMh8BY;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;ANk8BhB;AMh8BgB;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sCAAA;EACA,cAAA;ANk8BpB;AM/7BgB;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yCAAA;EACA,cAAA;ANi8BpB;AM57BY;EACI,kBAAA;EACA,sCAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AN87BhB;AM57BgB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AN87BpB;AM37BgB;EACI,sCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;AN67BpB;;AMn7BA;EACI;IACI,aAAA;ENs7BN;EMp7BE;IACI,mBAAA;IACA,iBAAA;IACA,gBAAA;ENs7BN;EMn7BM;IACI,SAAA;ENq7BV;EMp7BU;IACI,YAAA;IACA,aAAA;ENs7Bd;EMn7BU;IACI,SAAA;ENq7Bd;EMn7BkB;IACI,eAAA;IACA,iBAAA;ENq7BtB;EMl7BkB;IACI,eAAA;IACA,iBAAA;ENo7BtB;AACF","sourcesContent":["\n@font-face {\n  font-family: \"DINNextLTLight\";\n  src: url(\"./fonts/Linotype-DIN-Next-LT-Arabic-Light.ttf\")\n}\n@font-face {\n  font-family: \"DINNextLTRegular\";\n  src: url(\"./fonts/Linotype-DIN-Next-LT-Arabic-Regular.ttf\")\n}\n@font-face {\n  font-family: \"DINNextLTUltraLight\";\n  src: url(\"./fonts/Linotype-DIN-Next-LT-Arabic-UltraLight.ttf\")\n}\n@font-face {\n  font-family: \"DINNextLTMedium\";\n  src: url(\"./fonts/Linotype-DIN-Next-LT-Arabic-Medium.ttf\")\n}\n@font-face {\n  font-family: \"DINNextLTBold\";\n  src: url(\"./fonts/Linotype-DIN-Next-LT-Arabic-Bold.ttf\")\n}\n\n@font-face {\n  font-family: \"DINNextLTHeavy\";\n  src: url(\"./fonts/Linotype-DIN-Next-LT-Arabic-Heavy.ttf\")\n}\n@font-face {\n  font-family: \"DINNextLTBlack\";\n  src: url(\"./fonts/Linotype-DIN-Next-LT-Arabic-Black.ttf\")\n}\n\n#root{\n  position: relative;\n  overflow: hidden;\n}\n// \n:root {\n    --white-color: #ffffff;\n    --white-color-obicty: #FFFFFF29;\n    --black-color: #000000;\n    --black-color-obicty: #00000052;\n    //Primary colors\n    // Primary Colors\n    --primary-color: #EBDD36;\n    --primary-two-color: #231f20;\n    --primary-three-color: #020524;\n    //Secondary colors\n    --secondary-one-color: #32a361;\n    --secondary-two-color: #e01f3d;\n    --secondary-three-color: #e6cd2f;\n    --secondary-four-color: #204496;\n\n    // Font Family\n\n    \n    --font-din-next-Regular: DINNextLTRegular;\n    --font-din-next-Light: DINNextLTLight;\n    --font-din-next-UltraLight: DINNextLTUltraLight;\n    --font-din-next-Medium: DINNextLTMedium;\n    --font-din-next-Heavy: DINNextLTHeavy;\n    --font-din-next-Black: DINNextLTBlack;\n    --font-din-next-Bold: DINNextLTBold;\n\n\n\n\n    // Font Size\n    --font-heading-size: 40px;\n    --font-title-size: 24px;\n    --font-paragraphone-size: 24px;\n    --font-paragraphtwo-size: 16px;\n\n    --space-gap-sm: 8px;\n    --space-gap-md: 16px;\n\n    --border-radius-sm: 8px;\n    --border-radius-md: 16px;\n}\n\n@media (max-width: 992px) {\n  \n}\n* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    direction: rtl;\n    &:focus-visible {\n      outline: none !important;\n    }\n  }\n  div,p,span,h1,h2,h3,h4,h5,h6 {\n    margin: 0px;\n    padding: 0px;\n\n  }\n  a {\n    text-decoration: none !important;\n  }\n  .row {\n    display: flex;\n    flex-wrap: wrap;\n    margin: 0 -15px;\n  }\n  .h-100{\n    height: 100%;\n  }\n  .w-100{\n    width: 100%;\n  }\n  .d-flex{\n    display: flex;\n  }\n  .align-items-center{\n    align-items: center;\n  }\n  .align-items-start{\n    align-items: flex-start;\n  }\n  .align-items-end{\n    align-items: flex-end;\n  }\n  .justify-content-center{\n    justify-content: center;\n  }\n  .justify-content-between{\n    justify-content: space-between;\n  }\n  .justify-content-around{\n    justify-content: space-around;\n  }\n  .flex-column{\n    flex-direction: column;\n  }\n  .flex-row{\n    flex-direction: row;\n  }\n@import \"./modules/navbar.module.scss\";\n@import \"./modules/landing-page.module.scss\";\n@import \"./modules/success-page.module.scss\";\n@import \"./modules/loading.module.scss\";\n@import \"./modules/actions.module.scss\";\n@import \"./modules/not-found.module.scss\";",".navbar-landing {\n    padding: 25px 0px !important;\n\n    &__download {\n        padding: 12px 16px;\n        background-color: var(--white-color);\n        display: flex;\n        align-items: center;\n        gap: var(--space-gap-sm);\n        border-radius: var(--border-radius-sm);\n        -webkit-border-radius: var(--border-radius-sm);\n        -moz-border-radius: var(--border-radius-sm);\n        -ms-border-radius: var(--border-radius-sm);\n        -o-border-radius: var(--border-radius-sm);\n\n\n        .text {\n            font-size: 14px;\n            font-weight: 500;\n            color: var(--black-color);\n            font-family: var(--font-din-next-Medium);\n            height: 21px;\n            line-height: 15px;\n        }\n\n        .download {\n            width: 21px;\n            height: 21px;\n            object-fit: cover;\n        }\n    }\n\n    &__logo {\n        width: 44px;\n        height: 44px;\n        display: block;\n\n        .logo {\n            width: 100%;\n            height: 100%;\n            object-fit: cover;\n        }\n    }\n}\n\n@media screen and (max-width: 567px) {\n    .navbar-landing {\n        padding: 15px 0px 25px 0px !important;\n        /*\n        &__download {\n            display: none;\n        }\n        */\n    }\n}",".main-page {\n    width: 100%;\n    height: 100vh;\n    background-size: 100% 100%;\n    background-repeat: no-repeat;\n    background-position: center;\n    position: relative;\n\n    .overlay {\n        width: 100%;\n        height: 100%;\n        background: linear-gradient(180deg, rgba(15, 15, 15, 0) -1.79%, rgba(15, 15, 15, 0.9) 113.53%);\n    }\n}\n\n\n.landing-page {\n    height: calc(100vh - 95px);\n\n    .container {\n        height: 100%;\n    }\n\n    // padding-bottom: 50px;\n    &__flex-container {\n        display: flex;\n        align-items: end;\n        justify-content: space-between;\n        gap: 20px;\n        height: 100%;\n        padding-bottom: 20px;\n    }\n\n    &__form {\n        padding: 56px 40px;\n        background-color: var(--black-color-obicty);\n        border-radius: var(--border-radius-md);\n        -webkit-border-radius: var(--border-radius-md);\n        -moz-border-radius: var(--border-radius-md);\n        -ms-border-radius: var(--border-radius-md);\n        -o-border-radius: var(--border-radius-md);\n        min-height: 571px;\n        display: flex;\n        flex-direction: column;\n        gap: 40px;\n\n        .form__title {\n            width: 100%;\n            display: flex;\n            flex-direction: column;\n            gap: var(--space-gap-sm);\n\n            h5,\n            p {\n                color: var(--white-color);\n                text-align: right;\n            }\n\n            h5 {\n                font-weight: 700;\n                font-size: 25px;\n                line-height: 32.5px;\n                font-family: var(--font-din-next-Bold);\n            }\n\n            P {\n                font-weight: 400;\n                font-size: 18px;\n                line-height: 27px;\n                font-family: var(--font-din-next-Regular);\n            }\n        }\n\n        .form {\n            width: 100%;\n            display: flex;\n            flex-direction: column;\n            flex: 1;\n        }\n\n        ul.footerWrapper.formRelative {\n            .fmFooter {\n                padding: 0px !important;\n            }\n        }\n\n        form {\n            width: 100%;\n            display: flex;\n            flex-direction: column;\n            gap: 40px;\n\n            .from-control {\n                width: 100%;\n                display: flex;\n                flex-direction: column;\n                gap: 24px;\n            }\n\n            button {\n                width: 100%;\n                height: 45px;\n                background-color: var(--primary-color);\n                border-radius: 14px;\n                -webkit-border-radius: 14px;\n                -moz-border-radius: 14px;\n                -ms-border-radius: 14px;\n                -o-border-radius: 14px;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                gap: 8px;\n                cursor: pointer;\n\n                .text {\n                    font-family: var(--font-din-next-Bold);\n                    font-weight: bold;\n                    font-size: 14px;\n                    line-height: 21px;\n                    color: var(--black-color);\n                }\n\n                &:hover,\n                &:disabled {\n                    background-color: var(--primary-color);\n                    border-color: var(--primary-color);\n\n                    .text {\n                        color: #626262;\n                    }\n                }\n            }\n\n        }\n    }\n\n    &__content {\n        min-height: 304px;\n        display: flex;\n        flex-direction: column;\n        gap: 24px;\n\n        &__top {\n            display: flex;\n            flex-direction: column;\n            gap: 16px;\n            text-align: right;\n\n            .build-status {\n                padding: 8px 24px;\n                background-color: var(--white-color-obicty);\n                border-radius: 80px;\n                -webkit-border-radius: 80px;\n                -moz-border-radius: 80px;\n                -ms-border-radius: 80px;\n                -o-border-radius: 80px;\n                width: max-content;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n\n                .text {\n                    font-family: var(--font-din-next-Medium);\n                    font-weight: 500;\n                    font-size: 14px;\n                    line-height: 21px;\n                    color: var(--white-color);\n                }\n            }\n\n            h3.title {\n                font-size: 40px;\n                font-family: var(--font-din-next-Bold);\n                font-weight: 900;\n                line-height: 48px;\n                color: var(--white-color);\n            }\n\n            .location {\n                display: flex;\n                align-items: center;\n                flex-direction: row;\n                gap: 16px;\n\n                .icon-location {\n                    width: 28px;\n                    height: 28px;\n                    object-fit: cover;\n                }\n\n                .text {\n                    font-family: var(--font-din-next-Regular);\n                    font-weight: 400;\n                    font-size: 16px;\n                    line-height: 24px;\n                    color: var(--white-color);\n                }\n            }\n        }\n\n        &__basic-info {\n            width: max-content;\n            padding: 12px 24px;\n            background-color: var(--white-color-obicty);\n            border-radius: var(--border-radius-sm);\n            -webkit-border-radius: var(--border-radius-sm);\n            -moz-border-radius: var(--border-radius-sm);\n            -ms-border-radius: var(--border-radius-sm);\n            -o-border-radius: var(--border-radius-sm);\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            gap: 32px;\n            height: 83px;\n\n            &__card {\n                display: flex;\n                flex-direction: row;\n                gap: 16px;\n                -webkit-background-clip: padding-box;\n                background-clip: padding-box;\n                height: 100%;\n\n                &__icon {\n                    width: 24px;\n                    height: 24px;\n\n                    img {\n                        width: 100%;\n                        height: 100%;\n                        object-fit: cover;\n                    }\n                }\n\n                &__text {\n                    text-align: right;\n\n                    h6 {\n                        font-size: 16px;\n                        font-family: var(--font-din-next-Regular);\n                        font-weight: 400;\n                        line-height: 24px;\n                        color: var(--white-color);\n                    }\n\n                    p {\n                        font-size: 18px;\n                        font-family: var(--font-din-next-Regular);\n                        font-weight: 700;\n                        line-height: 27px;\n                        color: var(--white-color);\n\n                    }\n                }\n\n                &:last-child {\n                    border-left: none;\n                    padding-left: 0px;\n                    margin-left: 0px;\n                }\n            }\n\n            &__line {\n                width: 1px;\n                min-height: 80%;\n                max-height: 100%;\n                background-image: url(\"../../components/images/icon-line.jpg\");\n                opacity: 20%;\n            }\n\n        }\n\n        &__brind {\n            width: max-content;\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            gap: 4px;\n            border-radius: 5.89px;\n            padding: 5.89px 8px;\n            background-color: #FFFFFF;\n\n            img {\n                width: 175px;\n                height: 50px;\n\n\n            }\n\n            .text {\n                display: flex;\n                flex-direction: column;\n                align-items: center;\n                justify-content: center;\n                background-color: #05555C;\n                gap: 4px;\n                border-radius: 5.89px;\n                padding: 5px 15px;\n\n\n                .des {\n                    font-family: var(--font-din-next-Regular);\n                    font-weight: 400;\n                    font-size: 12px;\n                    line-height: 21px;\n                    color: var(--white-color);\n\n                }\n\n                .number {\n                    text-align: center;\n                    background-color: #FFFFFF;\n                    padding: 2px 5px;\n                    border-radius: 3px;\n                    -webkit-border-radius: 3px;\n                    -moz-border-radius: 3px;\n                    -ms-border-radius: 3px;\n                    -o-border-radius: 3px;\n                    font-family: var(--font-din-next-Regular);\n                    font-weight: 700;\n                    font-size: 12px;\n                    line-height: 21px;\n                    color: #000000;\n                }\n\n            }\n        }\n\n        &__app-story {\n            display: flex;\n            flex-direction: column;\n            justify-content: center;\n            gap: 16px;\n\n            h3 {\n                margin-bottom: 0px;\n                color: #FFFFFF;\n                font-size: 16px;\n                font-weight: 400;\n                line-height: 24px;\n                font-family: var(--font-din-next-Regular);\n            }\n\n            .list {\n                display: flex;\n                flex-direction: row;\n                align-items: center;\n                gap: 16px;\n\n                a {\n                    width: 150px;\n                    height: 44px;\n\n                    img {\n                        width: 100%;\n                        height: 100%;\n                    }\n                }\n\n            }\n\n        }\n\n    }\n\n    &__form-mob {\n        display: none;\n    }\n}\n\n\n.landing-page-app-story {\n    padding: 30px 0px;\n    background-color: #fff;\n    display: none;\n    flex-direction: column;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n    gap: 16px;\n\n    h3 {\n        margin-bottom: 0px;\n        color: #1C1B13;\n        font-size: 18px;\n        font-weight: 700;\n        line-height: 24px;\n        font-family: var(--font-din-next-Regular);\n    }\n\n    .list {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        gap: 16px;\n\n        a {\n            width: 150px;\n            height: 44px;\n\n            img {\n                width: 100%;\n                height: 100%;\n                object-fit: cover;\n            }\n        }\n\n    }\n}\n\n.landing-page-mob {\n    background-image: url(\"../../components/images/landing-page-mob.png\");\n    background-position: center;\n    background-size: cover;\n}\n\n@media (max-width: 992px) {\n    .main-page {\n        height: 80vh;\n\n        .overlay {\n            display: flex;\n            flex-direction: column;\n            justify-content: space-between;\n        }\n    }\n\n    .landing-page {\n        height: max-content;\n\n        &__flex-container {\n            align-items: end;\n            flex-direction: column;\n            gap: 0px;\n            height: 100%;\n            padding-bottom: 20px;\n        }\n\n        &__form {\n            padding: 20px 0px;\n            background-color: transparent;\n            border-radius: none;\n            -webkit-border-radius: none;\n            -moz-border-radius: none;\n            -ms-border-radius: none;\n            -o-border-radius: none;\n            min-height: fit-content;\n            display: flex;\n            flex-direction: column;\n            gap: 20px;\n            width: 100%;\n\n            .form__title {\n\n                h5,\n                p {\n                    color: #1C1B13;\n                }\n\n                h5 {\n                    font-size: 22px;\n                }\n\n                P {\n                    font-size: 14px;\n                    line-height: 21px;\n                }\n            }\n\n            form {\n                gap: 30px;\n\n                .from-control {\n                    gap: 16px;\n                }\n\n            }\n        }\n\n        &__content {\n            display: flex;\n            min-height: calc(70vh - 95px);\n            height: calc(70vh - 95px);\n            width: 100%;\n            gap: 24px;\n            padding-bottom: 24px;\n            justify-content: flex-end;\n\n            &__top {\n                display: flex;\n                flex-direction: column;\n                gap: 8px;\n                text-align: right;\n\n                .build-status {\n                    padding: 8px 8px;\n                    height: max-content;\n                }\n\n                h3.title {\n                    font-size: 22px;\n                    margin-bottom: 0px;\n                }\n\n                .location {\n                    gap: 8px;\n\n                    .text {\n                        font-size: 14px;\n                    }\n\n                }\n            }\n\n            &__basic-info {\n                width: max-content;\n                padding: 8px 12px;\n                gap: 16px;\n            }\n\n\n            &__brind {\n                gap: 2px;\n                width: 100%;\n                justify-content: space-between;\n\n                .text {\n                    width: 50%;\n                }\n            }\n\n        }\n\n        &__form-web {\n            display: none;\n        }\n    }\n\n\n}\n\n\n@media screen and (max-width: 576px) {\n    .main-page {\n        height: calc(100vh - 144px);\n    }\n\n    .landing-page {\n        flex: 1;\n\n        .container {\n            height: 95%;\n        }\n\n        &__flex-container {\n            justify-content: flex-end;\n            padding-bottom: 0px;\n            height: 100%;\n        }\n\n        &__content {\n            padding-bottom: 0px;\n\n            &__top {\n                .location {\n\n                    .icon-location {\n                        width: 16px;\n                        height: 16px;\n                    }\n                }\n            }\n\n            &__basic-info {\n                width: 100%;\n                gap: 16px;\n                padding: 8px;\n                height: 60px;\n\n                &__line {\n                    min-height: 90%;\n                }\n\n                &__card {\n                    gap: 5px;\n                    flex: 1;\n\n                    &__text {\n                        h6 {\n                            font-size: 12px;\n                            font-weight: 500;\n                            line-height: 18px;\n                            width: max-content;\n                        }\n\n                        p {\n                            font-size: 14px;\n                            font-family: var(--font-din-next-Medium);\n                            font-weight: 500;\n                            line-height: 21px;\n                            width: max-content;\n\n                        }\n                    }\n\n                }\n            }\n\n            &__app-story {\n                display: none;\n            }\n        }\n    }\n\n    .landing-page-app-story {\n        display: flex;\n        height: 144px;\n    }\n\n\n}",".main-page-success{\n    min-height: 100vh;\n    max-height: max-content;\n    \n}\n\n.success {\n    min-height: calc(100vh - 95px);\n    max-height: max-content;\n    \n    .container{\n        height: 100%;\n    }\n    &__flex-container {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        gap: 32px;\n        -webkit-gap :32px;\n        height: 100%;\n        padding-bottom: 20px;\n        -webkit-padding-bottom: 20px;\n\n        .success-image {\n            width: 160px;\n            height: 160px;\n\n            video {\n                width: 100% !important;\n                height: 100% !important;\n            }\n        }\n\n        .content {\n            display: flex;\n            flex-direction: column;\n            text-align: center;\n            justify-content: center;\n            align-items: center;\n            gap: 32px;\n\n        }\n\n        .top {\n            display: flex;\n            flex-direction: column;\n            text-align: center;\n            justify-content: center;\n            align-items: center;\n            gap: 16px;\n\n            h6 {\n                font-size: 36px;\n                font-weight: 700;\n                line-height: 46px;\n                margin-bottom: 0px;\n                font-family: var(--font-din-next-Bold);\n            }\n\n            p {\n                font-size: 25px;\n                font-weight: 400;\n                line-height: 31px;\n                margin-bottom: 0px;\n                font-family: var(--font-din-next-Regular);\n            }\n        }\n\n        .bottom {\n            display: flex;\n            flex-direction: column;\n            text-align: center;\n            justify-content: center;\n            align-items: center;\n            gap: 16px;\n\n            p {\n                margin-bottom: 0px;\n                color: #807F7B;\n                font-size: 16px;\n                font-weight: 400;\n                line-height: 24px;\n                font-family: var(--font-din-next-Regular);\n            }\n\n            .list {\n                display: flex;\n                flex-direction: row;\n                align-items: center;\n                gap: 16px;\n\n                a {\n                    width: 162px;\n                    height: 48px;\n\n                    img {\n                        width: 100%;\n                        height: 100%;\n                        object-fit: cover;\n                    }\n                }\n\n            }\n\n        }\n    }\n}\n\n\n\n\n@media screen and (max-width: 567px) {\n    .success {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        .container{\n            height: auto;\n        }\n        &__flex-container {\n            .success-image {\n                width: 140px;\n                height: 140px;\n            }\n\n            .top {\n                h6 {\n                    font-size: 22px;\n                    line-height: 28px;\n                }\n\n                p {\n                    font-size: 16px;\n                    line-height: 24px;\n                }\n            }\n\n            .bottom {\n                p {\n                    font-size: 14px;\n                    line-height: 21px;\n                }\n\n                .list {\n                    gap: 8px;\n\n                    a {\n                        width: 130px;\n                        height: 40px;\n                    }\n\n                }\n\n            }\n        }\n    }\n\n}",".loading{\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100vh;\n    background-color: rgba(0, 0, 0, 0.3);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n    background-color: #fff;\n    .loading__spinner{\n        width: 50px;\n        height: 50px;\n        border: 5px solid #f3f3f3;\n        border-top: 5px solid var(--primary-color);\n        border-radius: 50%;\n        animation: spin 2s linear infinite;\n    }\n    @keyframes spin {\n        0% { transform: rotate(0deg); }\n        100% { transform: rotate(360deg); }\n    }\n}",".input-form {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n\n    label {\n        font-family: var(--font-din-next-Regular);\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 21px;\n        color: var(--white-color);\n        text-align: right;\n        width: 100%;\n        margin-bottom: 0px;\n    }\n\n    input {\n        width: 100%;\n        height: 48px;\n        padding: 8px 16px;\n        border-radius: var(--border-radius-sm);\n        -webkit-border-radius: var(--border-radius-sm);\n        -moz-border-radius: var(--border-radius-sm);\n        -ms-border-radius: var(--border-radius-sm);\n        -o-border-radius: var(--border-radius-sm);\n        text-align: right;\n        font-family: var(--font-din-next-Light);\n        font-weight: 700;\n        background-color: #fff !important;\n\n        &::placeholder {\n            font-family: var(--font-din-next-Light);\n            font-weight: 700;\n            font-size: 14px;\n            color: #807F7B;\n            font-family: var(--font-din-next-Light);\n        }\n\n        &:focus {\n            outline: none;\n            border: var(--bs-border-width) solid var(--bs-border-color);\n            box-shadow: none;\n\n        }\n    }\n\n    input[type=\"email\"] {\n        direction: ltr;\n        text-align: left;\n        background-color: #fff !important;\n        &:focus{\n            background-color: #fff;\n        }\n    }\n\n}\n\n.form-group {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n\n    label {\n        font-family: var(--font-din-next-Regular);\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 21px;\n        color: var(--white-color);\n        text-align: right;\n        width: 100%;\n        margin-bottom: 0px;\n    }\n\n    .tel-phone {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        height: 48px;\n        background-color: var(--white-color);\n        direction: ltr;\n        border-radius: var(--border-radius-sm);\n        border: var(--bs-border-width) solid var(--bs-border-color);\n        padding: 8px 16px;\n\n        .tel-phone-code {\n            font-family: var(--font-din-next-Medium);\n            font-size: 14px;\n            color: #242926;\n            font-style: normal;\n            font-weight: 500;\n\n        }\n\n        .line {\n            width: 1px;\n            height: 24px;\n            background-color: #F0F0EF;\n\n        }\n\n        input {\n            height: 100%;\n            width: 100%;\n            flex: 1;\n            font-family: var(--font-din-next-Medium);\n            background-color: #fff !important;\n            font-size: 14px;\n            color: #242926;\n            font-style: normal;\n            font-weight: 500;\n            flex: 1;\n            direction: ltr;\n            border: var(--white-color);\n\n            &::placeholder {\n                color: #a3a3a3 !important;\n            }\n        }\n\n    }\n\n\n}\n\n.errorfiled {\n    color: #ff1010;\n    font-size: 14px;\n    font-family: var(--font-din-next-Regular);\n    font-weight: 600;\n}\n\n\n.is-invalid {\n    border: 2px solid red;\n\n}\n\n@media (max-width: 992px) {\n\n    .input-form,\n    .form-group {\n        label {\n            color: #1C1B13;\n        }\n\n    }\n}",".not-found {\n    height: calc(100vh - 95px);\n\n    // padding-bottom: 50px;\n    &__flex-container {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        gap: 65px;\n        height: 100%;\n\n        .image {\n            width: 397px;\n            height: 300px;\n\n            img {\n                width: 100%;\n                height: 100%;\n                object-fit: cover;\n            }\n        }\n\n        .content {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            justify-content: center;\n            gap: 32px;\n\n            .top {\n                display: flex;\n                flex-direction: column;\n                align-items: center;\n                justify-content: center;\n                gap: 16px;\n\n                h6 {\n                    font-size: 36px;\n                    font-weight: 700;\n                    line-height: 46px;\n                    margin-bottom: 0px;\n                    font-family: var(--font-din-next-Bold);\n                    color: #1C1B13;\n                }\n\n                p {\n                    font-size: 25px;\n                    font-weight: 400;\n                    line-height: 31px;\n                    margin-bottom: 0px;\n                    font-family: var(--font-din-next-Regular);\n                    color: #1C1B13;\n                }\n\n            }\n\n            .btn-home {\n                padding: 12px 24px;\n                background-color: var(--primary-color);\n                display: flex;\n                align-items: center;\n                gap: 8px;\n\n                img {\n                    width: 21px;\n                    height: 21px;\n                    object-fit: cover;\n                }\n\n                span {\n                    font-family: var(--font-din-next-Bold);\n                    font-weight: 700;\n                    font-size: 14px;\n                    line-height: 21px;\n                    color: var(--black-color);\n                }\n\n            }\n        }\n    }\n}\n\n\n\n@media screen and (max-width: 768px) {\n    .main-page.not {\n        height: 100vh;\n    }\n    .not-found {\n        height: min-content;\n        padding: 24px 0px;\n        margin-top: 40px;\n\n        // padding-bottom: 50px;\n        &__flex-container {\n            gap: 40px;\n            .image {\n                width: 200px;\n                height: 150px;\n            }\n\n            .content {\n                gap: 24px;\n                .top {\n                    h6 {\n                        font-size: 22px;\n                        line-height: 28px;\n                    }\n\n                    p {\n                        font-size: 16px;\n                        line-height: 24px;\n                    }\n                }\n            }\n        }\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
